import * as authSelectors from "../../auth/authSelectors";
import { CreateableSelectField } from "../../../components/forms/fields/CreateableSelectField";
import { useFieldArray, useFormContext } from "react-hook-form";
import {
  useCreateProductTag,
  useListProductTags,
} from "../../product-tags/service/product-tags-api";
import { useSelector } from "react-redux";
import { getErrorMessage } from "../../../error-handler";
import { toastr } from "react-redux-toastr";

export const ProductTagsSelectField = () => {
  const { control, watch, formState, getFieldState } = useFormContext();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  const { data } = useListProductTags(organizationKeyName);
  const { mutateAsync: createProductTag } = useCreateProductTag();

  const { append, replace } = useFieldArray({
    name: "tags",
    control,
  });

  const handleCreateProductTag = async (inputValue: string) => {
    try {
      const id = await createProductTag({
        data: {
          title: inputValue,
          name: inputValue,
        },
        organizationKeyName,
      });
      append(id);
    } catch (error: unknown) {
      const errorMessage = getErrorMessage(error);
      toastr.error("Error", errorMessage);
    }
  };

  return (
    <CreateableSelectField
      isMulti
      closeMenuOnSelect={false}
      label="Tags"
      helperText="Use tags to group products, and make it easy to find them when listing products."
      createOption={handleCreateProductTag}
      options={
        data?.map((tag) => ({
          label: tag.title,
          value: tag.id,
        })) || []
      }
      errorMessage={getFieldState("tags", formState).error?.message}
      onChange={(value) => {
        const newValue = value as { value: string; label: string }[];
        replace(newValue.map((val) => val.value));
      }}
      value={watch("tags")}
    />
  );
};
